define(function(require) {
    const JSV = require('civicsUtils/JSV');
  const Logger = require('civicsUtils/application/logger');
  const cache_utility = require('civicsUtils/cache_utility');
  return Backbone.Model.extend({
    idAttribute: 'id',
    formatUrlRoot: function(){
      this.urlRoot = this.urlRoot.format.apply(this.urlRoot,arguments);
    },
    resetKeyValues:function(binds){
      var self = this;
      if ( _.isArray(binds) && binds.length > 0 ){
        _.forEach(binds, b=>{
          self.resetKeyValue(b);
        });
      }
    },
    resetKeyValue:function(bind){
      var props = bind.split('.');
      if ( props.length == 1){
        var prop = this.get(props[0]);
        if ( prop ){
          //this.set(props[0],'0');
          this.unset(props[0],{silent:true});
          if ( this[props[0]]){
            delete this[props[0]];
          }
        }
      }
      else {
        var child = this.get(props.shift());
        if ( child && child.resetKeyValue ){
          child.resetKeyValue(props.join('.'))
        }
      }
    },
    url: function(){
      var myUrl = this.urlRoot;
      if (!this.isNew()){
        myUrl = this.urlRoot + "/" + this.get('id');
      }
      if( this.get('includeAttachments')){
        if( myUrl.indexOf('?') < 0)
            myUrl += "?IncludeAttachments=" + this.get('includeAttachments');
        else
            myUrl += "&IncludeAttachments=" + this.get('includeAttachments');
      }

      return myUrl;
    },
    toJSON: function(options) {
      var primAttrs = {};
      for (var attr in this.attributes) {
        var val = this.attributes[attr];
        if ( _.isObject(val) && val.toJSON){
          primAttrs[attr] = val.toJSON();
        }
        else {
          primAttrs[attr] = val;
        }
      }
      return _.clone(primAttrs);
    },
    get: function( key ) {
      if ( key && !_.isEmpty(key)){
        var keys = key.split(".");
        if ( keys.length == 1 ){
          //return Backbone.Model.prototype.get.apply( this, [keys] );
          return this.getIgnoreCase(keys[0]);
        }
        else{
          //var cm = Backbone.Model.prototype.get.apply( this, [keys[0]] );
          var cm = this.getIgnoreCase(keys[0]);
          if ( cm ){
            keys.shift();
            return cm.get( keys.join('.') );
          }
        }
      }
      return null;
    },
    getIgnoreCase:function(attr){
      attr = (attr + "").toLowerCase();
      for(var p in this.attributes){
         if(this.attributes.hasOwnProperty(p) && attr == (p+ "").toLowerCase()){
               return this.attributes[p];
          }
       }
    },
    hasProfile: function( key ) {
      //if (__DEV__) console.log('ipsModel.hasProfile -- key ', key);
      var activeProfiles = this.get('ActiveProfiles');
      if (typeof activeProfiles != 'undefined' && typeof key == 'string') {
        activeProfiles = activeProfiles.toJSON();
        for( var i = 0; activeProfiles && i < activeProfiles.length; i++){
          if( activeProfiles[i].name.toUpperCase() == key.toUpperCase()){
            //if (__DEV__) console.log('ipsModel.hasProfile -- return true');
            return true;
          }
        }
      }
      //if (__DEV__) console.log('ipsModel.hasProfile -- return false');
      return false;
    },
    set: function( key, value, options ) {
      // Duplicate backbone's behavior to allow separate key/value parameters, instead of a single 'attributes' object
      var attributes,
        result;
      if ( _.isObject( key ) || key == null ) {
        attributes = key;
        options = value;
        var self = this;
        var primAttrs = {};
        if ( !jQuery.isEmptyObject(attributes) ){
          // For each `set` attribute, update or delete the current value.
          for (var attr in attributes) {
            var val = attributes[attr];
            if ( _.isObject(val) && !(attr === "proxies")){
              if ( val.constructor === Array ) {
                // if the element in the array is not an object ( can't be converted into models ),
                // we just let it parsed as is
                // so if every element in the val is object, we will parse it as ipsModelCollection
                if ( _.every(val, function(ele){
                  return _.isObject(ele);
                })){
                  var IpsModelCollection = require('civicsBase/ipsModelCollection');
                  var col = new IpsModelCollection();
                  col.on('change', function(childModel, options) {
                      self.trigger('change', self, options);
                      self.changed[attr] = attr;  // do not store the reference to avoid memory leak
                  });
                  col.set(val);
                  primAttrs[attr] = col;
                }
                else {
                  primAttrs[attr] = val;
                }
              }
              else {
                var IpsModel = require('civicsBase/ipsModel');
                var cm = new IpsModel();
                cm.on('change', function(childModel, options) {
                    self.trigger('change', self, options);
                    self.changed[attr] = attr;  // do not store the reference to avoid memory leak
                });
                // need to set the self attr before the child so the change rule will run correctly
                this.attributes[attr] = cm;
                this.set(attr, cm);
                cm.set(val, options );
                //primAttrs[attr] = cm;
              }
            }
            else {
              primAttrs[attr] = val;
            }
          }
          var arg = [primAttrs, options];
          return Backbone.Model.prototype.set.apply( this,arg );
        }
      }
      else {
        var arg = [key,value, options];
        return Backbone.Model.prototype.set.apply( this,arg );
      }
    },
    fetch : function(options) {
      var self = this;
      var start = new Date();
      var urlText = _.isFunction(this.url)? this.url(): this.url;
      let localCacheEnabled = options && options.localCacheEnabled;
      if ( options && options.isSensitive) urlText=urlText.split("?")[0];

      var promise;
      if(localCacheEnabled){
        promise = self.checkLocalCacheData(urlText,options);
      }
      if(!promise){ 
        promise = Backbone.Model.prototype.fetch.apply(this, arguments)
          .done(function(result){
            if(localCacheEnabled){
              // note to dev: on parsing of the model, we need the structuredClone() to clone the response data of the fetch before modifying it on the parse so that the result will still return the original value from server
              // we need to save the result that is not yet modify by parse so that when we get it from cache and execute the parse, the result of parsing will still be the same.
              cache_utility.saveModelCacheData(urlText,options.localCacheGroupName,result);
            }
            self.setClean();
            var diff =  Math.abs(new Date() - start );
            Logger.logInfo('ipsModel:FetchSuccess'+diff+'ms:'+urlText);
          })
          .fail((jqXHR,textStatus,errorThrown)=>{
            var code = jqXHR.status;
            var text = textStatus;
            var error = errorThrown?errorThrown:'';
            var diff =  Math.abs(new Date() - start );
            Logger.logError('ipsModel:FetchFailed:'+
              diff+'ms:' +
              urlText +
              '[status:' +
              code + ', text:' +
              text + ', thrown: ' +
              error + ']');
              // isCheckAuthRequest indicates that the request came fro chekAuth so we don't need to login as anonymous when we encounter 401
              // loginAsAnonymous handle 401 error. To make sure that we always logged in as anonymous
              if(code == 401 && !options.isCheckAuthRequest){
                this.loginAsAnonymous();
              }
          })
          .then();
      }
      return promise;
    },
    loginAsAnonymous: function(){
      if(!App.processingAnonAuth){  // to make the auth call execute once
        App.processingAnonAuth = true;
        let loginAnonymousModel = Backbone.Model.extend({
          url: '/delegate/civics-api/api/anonymous/auth'
        });       
        if(__DEV__)console.log("Anonymous Login Start");
        let anonLogin = new loginAnonymousModel();
        anonLogin.fetch().done(()=>{
          window.location.reload();
        });
      }
    },
    save : function(key, val, options) {
      let localCacheGroupName = options && options.localCacheGroupName ? options.localCacheGroupName : undefined;
      // clear out the key for post
       if ( this[this.idAttribute] < 1000 ){
         this.unset(this.idAttribute);
         delete this.id;
       }
      // Git backbone issue #2489   there is pending commit for backbone model save not returning a promise object
      // not waiting on the decision. so we need to work on our own
      if ( _.isObject( key ) || key == null ) {
        options = val;
      }
      var res;
      if ( key ){
        res = this.set(key,val,options);
      }
      var getUrlText = true;
      var urlText = _.isFunction(this.url)? this.url(getUrlText): this.url;
      if ( options && options.isSensitive) urlText=urlText.split("?")[0];
      if ( (options && options.forceSave) || this.isNew() || this.hasChanged()){
         var start = new Date();
         res = Backbone.Model.prototype.save.apply(this, [null,options])
         .done(function(){
          if(localCacheGroupName){
            // invalidate the cache data by group after save
            cache_utility.clearInvalidCacheData(localCacheGroupName);
          }
           var diff =  Math.abs(new Date() - start );
           Logger.logInfo('ipsModel:SaveSuccess'+diff+'ms:'+urlText);
         })
         .fail(function(jqXHR,textStatus,errorThrown){
           var code = jqXHR.status;
           var text = textStatus;
           var error = errorThrown?errorThrown:'';
           var diff =  Math.abs(new Date() - start );
           Logger.logError('ipsModel:SaveFailed:'+
             diff+'ms:' +
             urlText +
             '[status:' +
             code + ', text:' +
             text + ', thrown: ' +
             error + ']');
         });
      }
      else{
        Logger.logInfo('ipsModel:SaveSkipped:'+urlText);
        // call success first...then return deferred for setting the done action
        if ( key == null || typeof key === 'object'){
          options = val;
        }
        if (options && options.success){
          options.success.call();
        }
        //setup the derred action object now
        var def = new $.Deferred();
        setTimeout(function () {
            //console.log('save skipped - clean model');
            def.resolve();
        },10);
        return def.promise(this, 'Success');
      }
      // if validation failed and return false instead of an xhr object
      if ( !res ){
          var dfd = new $.Deferred();
          return dfd.reject(this, 'Conflict');
      }
      else {
        return res;
      }
    },
    // use to check the cache if we have the data base on the url request
    // return it as the response of fetch and execute the option.success if we have it
    checkLocalCacheData: function(key,options){
      // always remove the expired data on cache before checking it
      cache_utility.clearInvalidCacheData();
      
      let requestCacheData = cache_utility.getModelCacheData(key);
      if(requestCacheData && requestCacheData.length > 0){
        retVal = requestCacheData[0].values;
        var def = $.Deferred();
        // if we found the data on cache, we need to execute the this.parse() to execute the model parse and set the result on current model
        let parseDataResult = this.parse(requestCacheData[0].values); 
        this.set(parseDataResult)
        if (options && options.success){
          // we need to execute the success from option because this will not be executed on resolve
          options.success(this,parseDataResult);
        }

        return def.resolve(retVal,'Success');
      }
      return;
    },
    setClean: function(){
      for (var attr in this.attributes) {
        var val = this.attributes[attr];
        if (  _.isObject(val) && val.setClean ){
          val.setClean();
        }
      }
      this.changed = [];
    },
    hasChanged: function(){
      var isChanged = !jQuery.isEmptyObject(this.changed);
      for (var attr in this.attributes) {
        var val = this.attributes[attr];
        if (  _.isObject(val) && val.hasChanged ){
          isChanged = isChanged || val.hasChanged();
        }
      }
      return isChanged;
    },
    parse:function(r){
      //if (__DEV__)console.log('model response', r);
      // if this is a response coming straight from IPS Rest services , handle the response status and return the data
      if ( r.responseStatus && r.data ){
        this.responseStatus = r.responseStatus;
        return r.data;
      }
      return r;
  },
  //ecode the url component
  encodeComponent: function (val) {
    //return val;
    val = JSV.escapeString(val);
    return encodeURIComponent(val);

  }
  });
});
